import { CollectionPricingHero } from "./collection-pricing-hero.tsx";

export const ServiceCollectionPricingHero = () => {
    return (
        <CollectionPricingHero
            orientation="vertical"
            collectionImage={{
                height: 48,
                width: 168,
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wq7706lsya8q6fb1sj2k15h48h450ssr.svg",
                alt: "Service Collection"
            }}
            products={[
                {
                    image: {
                        src: "	https://dam-cdn.atl.orangelogic.com/AssetLink/7jcq40x67167gax15ux7b27r5r575tk5.svg",
                        alt: "Jira Service Management"
                    }
                },
                {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/466ke7l5j3i276s3p7k5660c525ru38d.svg",
                        alt: "Customer Service Management"
                    }
                },
                {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hgm0up275i80h6m7b5j3f8t68a7fcp4.svg",
                        alt: "Assets"
                    }
                },
                {
                    name: "Rovo",
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kq772n08c357g2p82f8bnw824do06dn.svg",
                        alt: "Rovo"
                    }
                }
            ]}
        />
    );
};
